import { PropsWithChildren } from 'react'

import { ConfirmModal } from 'shared/components'
import { useTranslation } from 'libs/i18n'

type DeleteConfirmModalProps = PropsWithChildren<{
	isOpened: boolean
	title: string
	closeModal: () => void
	confirm: () => void
}>

export const DeleteConfirmModal = ({ children, ...props }: DeleteConfirmModalProps) => {
	const { t } = useTranslation()

	return (
		<ConfirmModal {...props} tone="danger" confirmText={t('Delete')}>
			{children}
		</ConfirmModal>
	)
}
